import { getFrontendEnv } from '@bm-js/atlascloud-shared'

/** APP_ENV is exposed to client code via envPrefix in each consuming app's vite.config.ts */
export const uiEnv = getFrontendEnv(import.meta.env.APP_ENV)
